export default __webpack_public_path__ + "static/media/de-addiction.93cdf7ed.png";